import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getRegisterSMSVerifyCode = (params, urlParams) => {
  return axios.request({
    url: '/clientaccount/getregistersmsverifycode/' + params.telephone + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getLoginSMSVerifyCode = (params, urlParams) => {
  return axios.request({
    url: '/clientaccount/getloginsmsverifycode/' + params.telephone + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const bindTelephone = (params, urlParams) => {
  return axios.request({
    url: '/clientaccount/bindtelephone/' + params.code + '/' + params.telephone + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const registerAndLoginByWebApp = (params, urlParams) => {
  return axios.request({
    url: '/clientaccount/registerandloginbywebapp' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

